var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","text-xs-center":""}},[_c('v-progress-linear',{attrs:{"size":100,"value":100,"color":"error"}}),_vm._v(" "),_c('h1',{staticClass:"display-3"},[_vm._v("Error "+_vm._s(_vm.rand(_vm.emoji)))]),_vm._v(" "),_c('h1',{staticClass:"display-1"},[_vm._v(_vm._s(_vm.rand(_vm.messages)))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d804330","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingError.vue
// module id = null
// module chunks = 